import type { TFunction } from 'i18next'

import { createBasicRule } from '../utils/create-basic-rule.ts'
import type { ValidationRuleFactory } from '../utils/types.ts'
import { invalidStringRule } from './invalid-string.ts'
import { invalidTypeRule } from './invalid-type.ts'
import { tooBigRule } from './too-big.ts'
import { tooSmallRule } from './too-small.ts'

export const defaultRuleFactory: ValidationRuleFactory<'validation'> = (
  t: TFunction<'validation'>
) => [
  createBasicRule('unrecognized_keys', 'unrecognized_keys', t, {
    joinArrays: ', ',
  }),
  createBasicRule('invalid_union', 'invalid_union', t),
  createBasicRule('invalid_value', 'invalid_value', t, {
    joinArrays: ', ',
  }),
  createBasicRule('invalid_key', 'invalid_key', t),
  createBasicRule('invalid_element', 'invalid_element', t),
  invalidTypeRule(t),
  invalidStringRule(t),
  tooSmallRule(t),
  tooBigRule(t),
  createBasicRule('not_multiple_of', 'not_multiple_of', t),
]
